"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeOrigin = getTimeOrigin;
exports.getNow = getNow;
exports.getElapsedTime = getElapsedTime;
exports.getPaintTiming = getPaintTiming;
exports.getNavigationTiming = getNavigationTiming;
exports.PaintTimeEvent = exports.LoadTimeEvent = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LoadTimeEvent;
exports.LoadTimeEvent = LoadTimeEvent;

(function (LoadTimeEvent) {
  LoadTimeEvent["DOM_COMPLETE"] = "domComplete";
  LoadTimeEvent["DOM_LOADING"] = "domLoading";
  LoadTimeEvent["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
  LoadTimeEvent["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
  LoadTimeEvent["LOAD_EVENT_START"] = "loadEventStart";
  LoadTimeEvent["LOAD_EVENT_END"] = "loadEventEnd";
})(LoadTimeEvent || (exports.LoadTimeEvent = LoadTimeEvent = {}));

var PaintTimeEvent;
exports.PaintTimeEvent = PaintTimeEvent;

(function (PaintTimeEvent) {
  PaintTimeEvent["FIRST_PAINT"] = "first-paint";
  PaintTimeEvent["FIRST_CONTENTFUL_PAINT"] = "first-contentful-paint";
})(PaintTimeEvent || (exports.PaintTimeEvent = PaintTimeEvent = {}));

var PAINT_OBSERVER_TIMEOUT_MS = 2000;
/**
 * Get the time of the beginning of the current document's lifetime
 */

function getTimeOrigin() {
  var _window = window,
      performance = _window.performance; // Browser does not support performance time tracking

  if (!performance) {
    return 0;
  }

  if (!!window.PerformanceNavigationTiming) {
    var entries = performance.getEntriesByType('navigation');
    return entries && entries.length ? entries[0].startTime : 0;
  }

  return performance.timing.navigationStart;
}
/**
 * Get performance.now accounting for differences between performance timing APIs
 */


function getNow() {
  var _window2 = window,
      performance = _window2.performance; // Browser does not support performance time tracking

  if (!performance) {
    return 0;
  } // When using the deprecated PerformanceTiming API
  // performance.timing.navigationStart + performance.now() is approx equal to Date.now()


  var perfNow = performance.now();
  return !!window.PerformanceNavigationTiming ? perfNow : performance.timing.navigationStart + perfNow;
}
/**
 * Calculate how much time has passed from given startTime
 */


function getElapsedTime(startTime) {
  var now = getNow();
  var elapsedTime = now - startTime; // Ensure a number is returned

  return typeof elapsedTime === 'number' && elapsedTime > 0 ? elapsedTime : 0;
}

function getPaintTiming(event) {
  if (typeof PerformanceObserver === 'undefined') {
    return Promise.resolve(0);
  }

  return new Promise(function (resolve) {
    var nonMatchingObserverTimeoutId;
    var paintObserver = new PerformanceObserver(function (list, observer) {
      var _list$getEntries$filt = list.getEntries().filter(function (entry) {
        return entry.name === event;
      }),
          _list$getEntries$filt2 = _slicedToArray(_list$getEntries$filt, 1),
          matchingPaintEntry = _list$getEntries$filt2[0];

      if (matchingPaintEntry) {
        observer.disconnect();
        clearTimeout(nonMatchingObserverTimeoutId);
        var timeOrigin = getTimeOrigin();
        var time = matchingPaintEntry.startTime - timeOrigin;
        return resolve(time);
      }
    });

    var observerFailure = function observerFailure() {
      paintObserver.disconnect();
      return resolve(PAINT_OBSERVER_TIMEOUT_MS);
    };

    nonMatchingObserverTimeoutId = setTimeout(observerFailure, PAINT_OBSERVER_TIMEOUT_MS);

    try {
      paintObserver.observe({
        entryTypes: ['paint']
      });
    } catch (error) {
      // Browser likely supports PerformanceObserver, but not the entryType of `paint`
      clearTimeout(nonMatchingObserverTimeoutId);
      return resolve(0);
    }
  });
}
/**
 * Gets the performance timing for the given key. Returns a Promise to guarantee a value
 */


function getNavigationTiming(timingEvent) {
  var _window3 = window,
      performance = _window3.performance; // Browser does not support performance time tracking

  if (!performance) {
    return Promise.resolve(0);
  } // Use W3 recommendation of PerformanceNavigationTiming API (not supported in IE or Safari) if available
  // Otherwise fall back to PerformanceTiming API, which is deprecated, but widely supported for now


  var canUsePerfNavTiming = typeof performance.getEntriesByType === 'function';
  var entriesByType = canUsePerfNavTiming ? performance.getEntriesByType('navigation') : [];
  var entries = entriesByType.length ? entriesByType[0] : performance.timing;

  if (!entries) {
    return Promise.resolve(0);
  } // Account for different time origins between peformance timing APIs
  // PerformanceTiming begins at the UNIX epoch
  // PerformanceNavigationTiming begins at the beginning of the current document's lifetime


  var timingDifference = canUsePerfNavTiming ? 0 : -performance.timing.navigationStart; // If the value is available return immediately

  if (entries[timingEvent] !== 0) {
    return Promise.resolve(entries[timingEvent] + timingDifference);
  } // Otherwise start a timer to return value when it exists


  var intervalId;
  return new Promise(function (resolve) {
    intervalId = window.setInterval(function () {
      if (entries[timingEvent]) {
        resolve(entries[timingEvent] + timingDifference);
        window.clearInterval(intervalId);
      }
    }, 2500);
  });
}